export const THEME_META_COLORS = {
  dark: '#121416',
  light: '#f3f5f7',
};

export function resolveTheme(theme) {
  if (theme === 'light') return 'light';
  return 'dark';
}

export function applyTheme(theme) {
  if (typeof document === 'undefined') return 'dark';

  const root = document.documentElement;
  const casinoLocked = root.dataset.casinoDark === '1';
  const preference = theme || 'dark';
  const resolved = casinoLocked ? 'dark' : resolveTheme(preference);

  root.dataset.theme = resolved;
  if (!casinoLocked) root.dataset.themePreference = preference === 'auto' ? 'dark' : preference;

  const metaColor = THEME_META_COLORS[resolved];
  root.style.backgroundColor = metaColor;
  document.body.style.backgroundColor = metaColor;

  const themeColorMeta = document.querySelector('meta[name="theme-color"]');
  if (themeColorMeta) themeColorMeta.setAttribute('content', metaColor);

  const schemeMeta = document.querySelector('meta[name="color-scheme"]');
  if (schemeMeta) schemeMeta.setAttribute('content', resolved);

  const boot = document.getElementById('app-boot');
  if (boot) boot.style.background = metaColor;

  return resolved;
}

export function readStoredTheme() {
  try {
    const raw = localStorage.getItem('vb_settings');
    if (!raw) return 'dark';
    const parsed = JSON.parse(raw);
    const theme = parsed?.theme || 'dark';
    return theme === 'auto' ? 'dark' : theme;
  } catch {
    return 'dark';
  }
}
